export enum ConvertSubphaseStatus {
  Running = 'running',
  Done = 'done',
  Rejected = 'rejected',
  NotStarted = 'not_started',
}

export const convertSubphaseStatusConfigs: Record<ConvertSubphaseStatus, { label: string }> = {
  [ConvertSubphaseStatus.Running]: {
    label: 'Running',
  },
  [ConvertSubphaseStatus.Done]: {
    label: 'Done',
  },
  [ConvertSubphaseStatus.Rejected]: {
    label: 'Rejected',
  },
  [ConvertSubphaseStatus.NotStarted]: {
    label: 'Not started',
  },
};
